module.exports = __webpack_public_path__ + "img/paypal_long.0241c00a.svg";